import ObjectHash from 'object-hash'

export const state = () => {
	return {
		statsGlobal: {},
		ttl_statsGlobal: {},
		cache_key_statsGlobal: {},

		statsConversion: {},
		ttl_statsConversion: {},
		cache_key_statsConversion: {},

		cache_duration: 10800000, // 3 hours
	}
}

function isInCacheStatsGlobal(state, statKey, companyId, params) {
	if (!state.ttl_statsGlobal[statKey] || state.ttl_statsGlobal[statKey] < Date.now()) {
		return false
	}

	const cacheKey = buildCacheKeyStatsGlobal(statKey, companyId, params)
	return state.cache_key_statsGlobal[statKey] === cacheKey
}

function buildCacheKeyStatsGlobal(statKey, companyId, params) {
	return `company:${companyId}:global::params:${ObjectHash(params)}:${statKey}`
}

function isInCacheStatsConversion(state, statKey, companyId, params) {
	if (!state.ttl_statsConversion[statKey] || state.ttl_statsConversion[statKey] < Date.now()) {
		return false
	}

	const cacheKey = buildCacheKeyStatsConversion(statKey, companyId, params)
	return state.cache_key_statsConversion[statKey] === cacheKey
}

function buildCacheKeyStatsConversion(statKey, companyId, params) {
	return `company:${companyId}:conversion::params:${ObjectHash(params)}:${statKey}`
}

export const actions = {
	async retrieveGlobalIndicators({ dispatch }, { companyId, statName, params, evolution }) {
		const statKey = evolution ? statName + '_evolution' : statName
		let endpoint = `api/company/${companyId}/referral-referral/stats-${statName}/`

		if (statName === 'revenue') {
			// special case for this new route before all api route paths are refactored to match new structure
			endpoint = `api/company/${companyId}/referral-referral/stats/${statName}/`
		}

		return await dispatch('retrieveStatGlobal', {
			endpoint,
			statKey,
			companyId,
			params,
		})
	},

	async retrieveStatGlobal({ state, commit }, { endpoint, statKey, companyId, params }) {
		if (isInCacheStatsGlobal(state, statKey, companyId, params)) {
			return state.statsGlobal[statKey]
		}
		return await useNuxtApp()
			.$api(endpoint, { params })
			.then((data) => {
				commit('setStatsGlobal', { statKey, data, companyId, params })
				return data
			})
			.catch((err) => {
				commit('clearCacheGlobal', { statKey })
				throw err
			})
	},

	async retrieveConversionIndicators({ dispatch }, { companyId, params, evolution }) {
		return await dispatch('retrieveStatConversion', {
			endpoint: `api/company/${companyId}/referral-referral/stats-conversion/`,
			statName: 'conversion',
			companyId,
			params,
			evolution,
		})
	},

	async retrieveConversionReferralsStates({ dispatch }, { companyId, params }) {
		return await dispatch('retrieveStatConversion', {
			endpoint: `api/company/${companyId}/referral-referral/stats-status-by-date/`,
			statName: 'referrals_states',
			companyId,
			params,
		})
	},

	async retrieveStatConversion(
		{ state, commit },
		{ endpoint, statName, companyId, params, evolution },
	) {
		const statKey = evolution ? statName + '_evolution' : statName
		if (isInCacheStatsConversion(state, statKey, companyId, params)) {
			return state.statsConversion[statKey]
		}
		return await useNuxtApp()
			.$api(endpoint, { params, statKey })
			.then((data) => {
				commit('setStatsConversion', { statKey, data, companyId, params })
				return data
			})
			.catch((err) => {
				commit('clearCacheConversion', { statKey })
				throw err
			})
	},
}

export const mutations = {
	setStatsGlobal(state, { statKey, data, companyId, params }) {
		state.statsGlobal = { ...state.statsGlobal, [statKey]: data }
		state.ttl_statsGlobal[statKey] = Date.now() + state.cache_duration

		const cacheKey = buildCacheKeyStatsGlobal(statKey, companyId, params)
		state.cache_key_statsGlobal[statKey] = cacheKey
	},

	setStatsConversion(state, { statKey, data, companyId, params }) {
		state.statsConversion = { ...state.statsConversion, [statKey]: data }
		state.ttl_statsConversion[statKey] = Date.now() + state.cache_duration

		const cacheKey = buildCacheKeyStatsConversion(statKey, companyId, params)
		state.cache_key_statsConversion[statKey] = cacheKey
	},

	clearCacheGlobal(state, { statKey }) {
		state.statsGlobal[statKey] = null
		state.ttl_statsGlobal[statKey] = null
		state.cache_key_statsGlobal[statKey] = null
	},

	clearCacheConversion(state, { statKey }) {
		state.statsConversion[statKey] = null
		state.ttl_statsConversion[statKey] = null
		state.cache_key_statsConversion[statKey] = null
	},
}
